import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { Html5QrcodeScanner } from "html5-qrcode";
import { FaQrcode } from "react-icons/fa";
import GlobalNav from "../components/GlobalNav";


function QRScanner({ user }) {
  const navigate = useNavigate();
  const [scanResult, setScanResult] = useState(null);

  useEffect(() => {
    // Initialize the scanner
    const scanner = new Html5QrcodeScanner(
      "reader", // ID of the HTML element
      { 
        fps: 10, 
        qrbox: { width: 250, height: 250 },
        rememberLastUsedCamera: true,
        supportedScanTypes: [0] // Only look for QR codes (0) to save battery
      },
      false // Verbose logging off
    );

    // What happens when a QR code is successfully scanned
    const onScanSuccess = (decodedText) => {
      setScanResult(decodedText);
      scanner.clear(); // Stop scanning and turn off the camera

      // If the QR code is a URL belonging to your app, navigate to it
      if (decodedText.includes(window.location.origin)) {
        // Extract the path (e.g., "/scan/12345") and navigate using React Router
        const path = decodedText.replace(window.location.origin, "");
        navigate(path);
      } else {
        // If it's an external URL or just text, you can handle it here
        toast.info("Scanned Code: " + decodedText);
      }
    };

    // What happens when scanning fails (usually just noise, we ignore it)
    const onScanFailure = (error) => {
      // console.warn(`Code scan error = ${error}`);
    };

    // Start the scanner
    scanner.render(onScanSuccess, onScanFailure);

    // CLEANUP: Turn off the camera when the user leaves the page
    return () => {
      scanner.clear().catch(error => console.error("Failed to clear scanner", error));
    };
  }, [navigate]);

  return (
    <div className="container mt-4 pb-5 text-center">
      <GlobalNav user={user} />

      <div className="card shadow-sm border-0 border-top border-5 border-dark mx-auto mt-3" style={{maxWidth: '500px'}}>
        <div className="card-body p-4">
          <h4 className="fw-bold mb-3"><FaQrcode className="me-2 text-primary"/> Scan Safety Code</h4>
          <p className="text-muted small mb-4">
            Point your camera at a SiteWise QR sticker to instantly open the associated document or equipment log.
          </p>

          {/* The div where the camera feed will be injected */}
          <div id="reader" className="w-100 rounded overflow-hidden shadow-sm border"></div>

          {scanResult && (
            <div className="alert alert-success mt-4 mb-0 fw-bold">
              Code detected! Redirecting...
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QRScanner;